import React from 'react';
import { useTranslation } from "react-i18next";
import { useAuth } from '../../../context/AuthContext';
import Swal from 'sweetalert2';
import axios from "axios";
import { API_BASE_URL } from "../../../Helpers/apiConfig";

const GeneralProfile = () => {
    const { t } = useTranslation();
    const { user, setUser } = useAuth();
    const isAdmin = user.user.roleName === "SysAdmin";

    // Sadece admin: e-postayı UpdateUser ile değiştirir. Diğer alanlar sunucudaki güncel
    // değerleriyle aynen gönderilir; not ve durum gönderilmez, backend kayıtlı değerleri korur.
    const handleEmailSubmit = async (e) => {
        e.preventDefault();
        const newEmail = document.getElementById("adminEmail").value.trim();
        if (newEmail.toLowerCase() === (user.user.username || "").toLowerCase()) {
            Swal.fire({ title: "Bilgi", text: "Bu zaten mevcut e-posta adresiniz.", icon: "info", confirmButtonText: "Tamam" });
            return;
        }

        const confirm = await Swal.fire({
            title: "E-posta değiştirilsin mi?",
            text: `Girişlerde ve şifre sıfırlamada artık ${newEmail} kullanılacak. Adres doğrulanmadığı için doğru yazdığınızdan emin olun.`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Değiştir",
            cancelButtonText: "Vazgeç"
        });
        if (!confirm.isConfirmed) return;

        try {
            const headers = { "Authorization": "Bearer " + user.token };
            const [userRes, rolesRes] = await Promise.all([
                axios.get(API_BASE_URL + "/admin/User/GetUserById", { params: { userId: user.user.id }, headers }),
                axios.get(API_BASE_URL + "/admin/Role/GetList", { headers })
            ]);
            const current = userRes.data.data.user;
            const detail = userRes.data.data.detail;
            const role = rolesRes.data.data.find((r) => r.roleName === current.roleName);
            if (!role) throw new Error("Rol bilgisi alınamadı.");

            const res = await axios.put(API_BASE_URL + "/admin/User/UpdateUser", {
                id: current.id,
                username: newEmail,
                fullName: current.fullName,
                roleId: role.id,
                createdAt: current.createdAt,
                lastLogin: current.lastLogin,
                expiryDate: current.expiryDate,
                isTrial: current.isTrial,
                isVerified: current.isVerified,
                isInvidual: current.isInvidual,
                isStudent: current.isStudent,
                isManager: current.isManager,
                schoolId: detail.schoolId,
                classId: detail.classId,
                sectionId: detail.sectionId
            }, { headers });

            if (res.data.success) {
                setUser({ ...user, user: { ...user.user, username: newEmail } });
                Swal.fire({
                    title: "Başarılı",
                    text: "E-posta adresiniz değiştirildi. Bir sonraki girişinizde yeni adresi kullanın.",
                    icon: "success",
                    confirmButtonText: "Tamam"
                });
            } else {
                // Username tekil indeksine takılınca backend ham EF mesajı döndürüyor.
                Swal.fire({
                    title: "Hata",
                    text: (res.data.message || "").includes("saving the entity")
                        ? "E-posta kaydedilemedi. Bu adres başka bir hesapta kullanılıyor olabilir."
                        : res.data.message,
                    icon: "error",
                    confirmButtonText: "Tamam"
                });
            }
        } catch (err) {
            Swal.fire({ title: "Hata", text: err.response?.data?.message || err.message, icon: "error", confirmButtonText: "Tamam" });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const headerss = {
                "accept": "*/*",
                "Content-Type": "application/json",
                "Access-Control-Allow-Credentials": "false",
                "Authorization": "Bearer " + user.token
            };

            const res = await axios.post(
                API_BASE_URL + "/user/Opt/UpdateFullName",
                {
                    fullName: document.getElementById("name").value
                },
                { headers: headerss }
            );

            if (res.status === 200 && res.data.success) {
                Swal.fire({
                    title: "Başarılı",
                    text: "Adınız ve soyadınız başarıyla değiştirildi.",
                    icon: "success",
                    confirmButtonText: "Tamam"
                });
                console.log()
            } else {
                Swal.fire({
                    title: t("error"),
                    text: res.data.message,
                    icon: "error",
                    confirmButtonText: "Tamam"
                });
            }
        } catch (err) {
            console.log();
        }
    }

    return (
        <div className="container my-5">
            <div className="row justify-content-center">
                <div className="col-md-6">

                    <div className="card shadow-sm">
                        <div className="card-body">

                            <h3 className="text-center mb-4">
                                {t("profile")}
                            </h3>

                            <form onSubmit={handleSubmit}>

                                <div className="mb-3">
                                    <label
                                        htmlFor="name"
                                        className="form-label"
                                    >
                                        {t("namesurname")}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        defaultValue={user.user.fullName}
                                    />
                                </div>



                                <div className="d-grid">
                                    <button
                                        type="submit"
                                        className="btn btn-primary btn-lg"
                                    >
                                        {t("update")}
                                    </button>
                                </div>

                            </form>

                            {isAdmin && (
                                <form onSubmit={handleEmailSubmit} className="mt-4">
                                    <div className="mb-3">
                                        <label htmlFor="adminEmail" className="form-label">
                                            {t("email")}
                                        </label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            id="adminEmail"
                                            defaultValue={user.user.username}
                                            required
                                        />
                                    </div>
                                    <div className="d-grid">
                                        <button type="submit" className="btn btn-primary btn-lg">
                                            {t("update")}
                                        </button>
                                    </div>
                                </form>
                            )}

                        </div>
                    </div>

                    <hr className="mt-4" />
                    <h6 className="text-center mt-4 text-muted"> Hesabınızın geçerlilik süresi: <br />
                        {user.user.expiryDate ? ` ${new Date(user.user.expiryDate).toLocaleDateString()} tarihine kadar geçerlidir.` : ""}
                    </h6>
                </div>
            </div>
        </div >
    );
};

export default GeneralProfile;
